import React from "react";

function Terms() {
    return (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <p className="pt-5">
                        Welcome to Rapid Cash for Cars, a company that
                        specializes in auto recycling services. Please read the
                        following terms and conditions carefully before using
                        our services. By using our services, you agree to be
                        bound by these terms and conditions.
                    </p>
                    <br />
                    <h4>1. Acceptance of Terms</h4>
                    <p>
                        By using our services, you acknowledge that you have
                        read, understood, and agree to be bound by these terms
                        and conditions. Rapid Cash for Cars reserves the right
                        to change, modify, add, or remove portions of these
                        terms and conditions at any time without prior notice.
                        It is your responsibility to review these terms and
                        conditions regularly to ensure that you are aware of any
                        changes. Your continued use of our services after
                        changes are made to these terms and conditions
                        constitutes your acceptance of the revised terms.
                    </p>
                    <br />
                    <h4>2. Services</h4>
                    <p>
                        Rapid Cash for Cars provides auto recycling services,
                        including the purchase of used vehicles. We will
                        purchase your vehicle in exchange for cash payment. The
                        amount of payment will be determined based on several
                        factors, including the make, model, year, and condition
                        of the vehicle.
                    </p>
                    <br />
                    <h4>3. Ownership and Title</h4>
                    <p>
                        By selling your vehicle to Rapid Cash for Cars, you
                        warrant that you are the legal owner of the vehicle and
                        that you have the right to sell it. You agree to
                        transfer ownership and title of the vehicle to Rapid
                        Cash for Cars upon purchase.
                    </p>
                    <br />
                    <h4>4. Vehicle Condition</h4>
                    <p>
                        You agree to provide accurate information about the
                        condition of the vehicle you are selling to Rapid Cash
                        for Cars. We reserve the right to refuse to purchase any
                        vehicle that does not meet our standards for condition
                        or that has undisclosed damage.
                    </p>
                    <br />
                    <h4>5. Liability</h4>
                    <p>
                        Rapid Cash for Cars is not responsible for any damage or
                        injury resulting from the use of our services. You agree
                        to indemnify and hold us harmless from any claims,
                        damages, or expenses arising from the sale of your
                        vehicle or the use of our services.
                    </p>
                    <br />
                    <h4>6. Governing Law</h4>
                    <p>
                        These terms and conditions shall be governed by and
                        construed in accordance with the laws of the state in
                        which Rapid Cash for Cars is located.
                    </p>
                    <br />
                    <h4>7. Entire Agreement</h4>
                    <p>
                        These terms and conditions constitute the entire
                        agreement between you and Rapid Cash for Cars and
                        supersede all prior agreements and understandings,
                        whether written or oral.
                    </p>
                    <br />
                    <h4>8. Contact Information</h4>
                    <p>
                        If you have any questions or concerns about these terms
                        and conditions or our services, please contact us at
                        1300174519.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Terms;
